import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Logs } from '../app.urls';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private http: HttpClient) { }

  handleError(error: any): void {
    console.error('Global error:', error);
    // this.logErrors(error.toString());
  }

  logErrors(error: any): void {
    const domain = window.location.hostname;
    const errorLog: any = {
      logLevel:"Error",
      message: error,
      domain: domain,
      subdomain: this.getSubdomain(),
      stacktrace: 'Error from ' + window.location.hash + ' page ' + error,
      code: '4001'
    };

    // Code: 4001 is just used to identify application level error

    this.http.post<any>(Logs.logError, errorLog, { 'headers': { 'content-type': 'application/json' } }).subscribe((data) => {
      if (!data) {
        console.log('Failed to log.');
      }
    }, (error: any) => {
      console.log('Failed to log.');
    });

  }

  getSubdomain(): string {
    const domain = window.location.hostname;
    let subdomain: string = '';
    if (
      domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'example' ||
      domain.split('.')[0] === 'lvh' ||
      domain.split('.')[0] === 'www'
    ) {
      subdomain = 'drr';
    } else {
      subdomain = domain.split('.')[0];
    }
    return subdomain;
  }
}

export enum routeManagement {
  Items = "Items",
  Roles = "Roles",
  Tags = "Tags",
  TagType = 'tagtype',
  Tests = "Tests",
  Users = "Users",
  Reports = "Reports",
  Examinees = "examinee-group",
  Collections = "Collections",
  RoleDisabled = "RoleDisabled",
  Subscription = "subscription"
}
